import React, { useState, useEffect, FC } from "react";
import ActivityLog from "./activity-log";
import SendDigitalModal from "./send-digital-modal";
import { useSelector} from "react-redux";
import { RootState } from "../../../redux/store";
import moment from "moment";
import { DATE_TIME_FORMATS } from "../../../data/constants";
import "./style.scss";
import { getBillHtml } from "../../../helpers/accounting-helper";

interface Props {
  closeInvoiceDetails: any;
  hideBackButton?: boolean; 
}

const InvoiceSummary: FC<Props> = ({ closeInvoiceDetails, hideBackButton= false }) => {
  const [activityLog, setActivityLog] = useState<boolean>(false);
  const [billHTML, setBillHTML] = useState<any>({});
  const [sendDigitalModal, setSendDigitalModal] = useState<boolean>(false);
  const invoiceDetails = useSelector(
    (state: RootState) => state.accountingReducer?.invoiceDetails || {}
  );

  useEffect(() => {
        if(Object.keys(invoiceDetails)?.length>0){
        let html = getBillHtml(invoiceDetails);
        setBillHTML(html);
        }
  }, [invoiceDetails]);

  const handleButtonClick = () => {
    closeInvoiceDetails();
  };

  function toggleActivityLog() {
    setActivityLog((activityLog) => !activityLog);
  }
  function toggleSendDigitalBillModal() {
    setSendDigitalModal(!sendDigitalModal);
  }

  return (
    <div className="sale-summary-container border border-[#DDDDDD] rounded-[12px] m-24 smd:m-20">
      <div className="relative pt-[74px] h-[100%]">
        <div
          className={`sale-summary-header flex items-center justify-between px-20 py-15 border-b border-[#DDDDDD]`}
        > 
            <div className="flex smd:flex-col">
              <div className="flex">
            {!hideBackButton && <div
              className="rista-sprite ic-arrow-grey-back cursor-pointer"
              onClick={handleButtonClick}
            ></div>}
              <div className="flex-1 text-[18px] ml-5 text-black pr-5 sm:text-[18px] font-inter  font-semibold">
                {invoiceDetails?.billNumber}
              </div>
              </div>
              <div className="opacity-50 pl-8 border-l-2 smd:border-none  ml-5">
                {moment(invoiceDetails?.createdDate).format(
                  DATE_TIME_FORMATS.dayMonthTime
                )}
              </div>
          </div>
          <div className="flex">
            <span
              className="rista-sprite ic-activity-log-icon cursor-pointer hover:shadow-[0px_3px_6px_#00000029] !p-[8px] items-center !gap-[10px]  rounded-[6px]"
              onClick={() => setActivityLog(true)}
            ></span>
            <span
              className="rista-sprite ic-digital-bill-icon cursor-pointer hover:shadow-[0px_3px_6px_#00000029] !p-[8px] bg-[#397EF51A] !gap-[10px] rounded-[6px] ml-6"
              onClick={() => setSendDigitalModal(true)}
            ></span>
          </div>
        </div>

        <div
          className="main-body-ctn h-[70vh] w-full overflow-y-scroll p-32 smd:!p-16 sm:text-13 !text-[14px] sm:h-[75vh] "
          dangerouslySetInnerHTML={{ __html: billHTML }}
        />

        <ActivityLog
          isOpen={activityLog}
          handleClose={toggleActivityLog}
          data={invoiceDetails}
        />
        {sendDigitalModal && (
          <SendDigitalModal
            data={invoiceDetails}
            handleClose={toggleSendDigitalBillModal}
          />
        )}
      </div>
    </div>
  );
};

export default InvoiceSummary;
